import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import {
  CreateEditUserToPageRoleForm,
  CreateEditUserToPageRoleFormProps,
} from '../../../_lib/Form2/standardForms/CreateEditRoleForm/CreateEditUserToPageRoleForm';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { BlockType } from '../../../types/api/ElementType';
import useRedirect from '../../../hooks/useRedirect';
import { AxiosResponse } from 'axios';

function UserToPageRolePageLeadEdit({ form }: CreateEditUserToPageRoleFormProps) {
  const { delayedRefresh } = useRefreshBlock();
  const [startRedirect] = useRedirect();

  const onSuccess = (response: AxiosResponse) => {
    if (response?.data?.url) {
      startRedirect(response.data.url);
    } else {
      delayedRefresh();
    }
  };

  const { elementType } = useBlockContext<BlockType.usertouserrolepagelead | BlockType.usertopagerolepagelead>();

  return <CreateEditUserToPageRoleForm form={form} onSuccess={onSuccess} elementType={elementType} isEditing={true} />;
}

export const UserToPageRolePageLeadEditView = asFetchableView(UserToPageRolePageLeadEdit);
export type UserToPageRolePageLeadEditView = ComponentProps<typeof UserToPageRolePageLeadEditView>;
